/* shop-by-category.js */
document.addEventListener('DOMContentLoaded', () => {
    const section = document.querySelector('[data-section-type="shop-by-category"]');
    if (!section) return;

    // --- New Hover Logic (page3Animation) ---
    const elemC = section.querySelector("#elem-container");
    const fixed = section.querySelector("#fixed-image");

    if (elemC && fixed) {
        const elems = section.querySelectorAll(".elem");

        // Lazy load images only when needed (performance optimization)
        const loadedImages = new Map();
        
        const loadImage = (elem) => {
            const imageUrl = elem.getAttribute("data-image");
            const imageUrl2x = elem.getAttribute("data-image-2x");
            
            if (!imageUrl) return;
            
            // Check if already loaded
            if (loadedImages.has(imageUrl)) {
                return loadedImages.get(imageUrl);
            }
            
            // Use 2x image for retina displays, otherwise use 1x
            const urlToLoad = (window.devicePixelRatio > 1 && imageUrl2x) ? imageUrl2x : imageUrl;
            
            const img = new Image();
            const promise = new Promise((resolve, reject) => {
                img.onload = () => {
                    loadedImages.set(imageUrl, img);
                    elem.dataset.imagePreloaded = 'true';
                    resolve(img);
                };
                img.onerror = reject;
                img.src = urlToLoad;
            });
            
            loadedImages.set(imageUrl, promise);
            return promise;
        };
        
        // Preload only first visible image after page load
        const preloadFirstImage = () => {
            if (elems.length > 0) {
                // Use requestIdleCallback for non-critical preloading
                if ('requestIdleCallback' in window) {
                    requestIdleCallback(() => {
                        loadImage(elems[0]);
                    }, { timeout: 2000 });
                } else {
                    setTimeout(() => loadImage(elems[0]), 2000);
                }
            }
        };
        
        // Start preloading first image after page is interactive
        if (document.readyState === 'complete') {
            preloadFirstImage();
        } else {
            window.addEventListener('load', preloadFirstImage);
        }

        // Function to check if mouse is within section bounds
        const isMouseInSection = (e) => {
            const sectionRect = section.getBoundingClientRect();
            return (
                e.clientX >= sectionRect.left &&
                e.clientX <= sectionRect.right &&
                e.clientY >= sectionRect.top &&
                e.clientY <= sectionRect.bottom
            );
        };

        // Function to grey out all other categories
        const greyOutOthers = (currentElem) => {
            elems.forEach(elem => {
                if (elem !== currentElem) {
                    elem.classList.add('greyed-out');
                } else {
                    elem.classList.remove('greyed-out');
                }
            });
        };

        // Function to remove greyed-out state from all
        const removeGreyOut = () => {
            elems.forEach(elem => {
                elem.classList.remove('greyed-out');
            });
        };

        // Function to calculate image position constrained to section bounds
        const calculateImagePosition = (mouseY) => {
            const sectionRect = section.getBoundingClientRect();
            const imageHeight = fixed.offsetHeight || 0;
            const imageWidth = fixed.offsetWidth || 0;

            // Center image vertically on mouse Y position
            let top = mouseY - (imageHeight / 2);

            // Constrain to section bounds (top and bottom)
            const minTop = sectionRect.top;
            const maxTop = sectionRect.bottom - imageHeight;
            top = Math.max(minTop, Math.min(maxTop, top));

            return top;
        };

        // Track current hovered element
        let currentHoveredElem = null;
        let hideImageTimeout = null;
        let lastMousePosition = { x: 0, y: 0 };

        // Function to show image
        const showImage = (elem, mouseY) => {
            // Clear any pending hide timeout
            if (hideImageTimeout) {
                clearTimeout(hideImageTimeout);
                hideImageTimeout = null;
            }

            const image = elem.getAttribute("data-image");
            if (image && fixed) {
                // Lazy load image if not already loaded
                if (!elem.dataset.imagePreloaded) {
                    loadImage(elem).then(() => {
                        fixed.style.backgroundImage = `url(${image})`;
                    });
                } else {
                    fixed.style.backgroundImage = `url(${image})`;
                }
                fixed.style.display = "block";

                // Update Y position based on current mouse position, constrained to section
                const top = calculateImagePosition(mouseY);
                fixed.style.top = `${top}px`;

                // Smooth transition
                requestAnimationFrame(() => {
                    fixed.style.opacity = "1";
                });
            }
        };

        // Function to hide image
        const hideImage = () => {
            fixed.style.opacity = "0";
            hideImageTimeout = setTimeout(() => {
                fixed.style.display = "none";
                hideImageTimeout = null;
            }, 300);
        };

        // Update image position when mouse moves within section (even between categories)
        section.addEventListener("mousemove", function (event) {
            // Track last mouse position
            lastMousePosition.x = event.clientX;
            lastMousePosition.y = event.clientY;

            if (fixed && fixed.style.display === "block" && currentHoveredElem && isMouseInSection(event)) {
                const top = calculateImagePosition(event.clientY);
                fixed.style.top = `${top}px`;
            }
        });

        // Hide image only when leaving the entire section
        section.addEventListener("mouseleave", function () {
            if (hideImageTimeout) {
                clearTimeout(hideImageTimeout);
            }
            hideImage();
            removeGreyOut();
            currentHoveredElem = null;
        });

        // Hide image when scrolling starts
        let scrollTimeout = null;
        let scrollCheckTimeout = null;

        window.addEventListener("scroll", function () {
            // Hide image immediately when scroll starts
            if (fixed && fixed.style.display === "block" && currentHoveredElem) {
                hideImage();
                removeGreyOut();
                currentHoveredElem = null;
            }

            // Debounce to check if mouse is still over element after scroll
            if (scrollCheckTimeout) {
                clearTimeout(scrollCheckTimeout);
            }

            scrollCheckTimeout = setTimeout(() => {
                if (fixed && fixed.style.display === "block" && currentHoveredElem) {
                    // Check if section is still in viewport
                    const sectionRect = section.getBoundingClientRect();
                    const sectionInView = (
                        sectionRect.bottom >= 0 &&
                        sectionRect.top <= window.innerHeight
                    );

                    if (!sectionInView) {
                        // Section scrolled out of view - ensure image is hidden
                        hideImage();
                        removeGreyOut();
                        currentHoveredElem = null;
                        return;
                    }

                    // Check if mouse is still within section bounds
                    const mouseInSection = (
                        lastMousePosition.x >= sectionRect.left &&
                        lastMousePosition.x <= sectionRect.right &&
                        lastMousePosition.y >= sectionRect.top &&
                        lastMousePosition.y <= sectionRect.bottom
                    );

                    // Check if mouse is still over the current hovered element
                    const elemRect = currentHoveredElem.getBoundingClientRect();
                    const mouseOverElement = (
                        lastMousePosition.x >= elemRect.left &&
                        lastMousePosition.x <= elemRect.right &&
                        lastMousePosition.y >= elemRect.top &&
                        lastMousePosition.y <= elemRect.bottom
                    );

                    // If mouse is not in section or not over the element, ensure image is hidden
                    if (!mouseInSection || !mouseOverElement) {
                        hideImage();
                        removeGreyOut();
                        currentHoveredElem = null;
                    }
                }
            }, 150); // Check after scroll settles
        }, { passive: true });

        // Handle hover on individual category elements
        elems.forEach(function (e, index) {
            // Add staggered animation on load
            e.style.animationDelay = `${index * 0.1}s`;

            e.addEventListener("mouseenter", function (event) {
                // Only show if mouse is inside section
                if (!isMouseInSection(event)) return;

                currentHoveredElem = e;

                // Show image for this category
                showImage(e, event.clientY);

                // Grey out other categories
                greyOutOthers(e);
            });

            e.addEventListener("mousemove", function (event) {
                // Update image Y position as mouse moves within the element
                // Only update if this is the currently hovered element
                if (fixed && fixed.style.display === "block" && currentHoveredElem === e && isMouseInSection(event)) {
                    const top = calculateImagePosition(event.clientY);
                    fixed.style.top = `${top}px`;
                }
            });

            e.addEventListener("mouseleave", function (event) {
                // Check if we're moving to another category element
                const relatedTarget = event.relatedTarget;
                const movingToAnotherCategory = relatedTarget && relatedTarget.closest('.elem');

                if (!movingToAnotherCategory) {
                    // Not moving to another category - hide image
                    if (currentHoveredElem === e) {
                        hideImage();
                        removeGreyOut();
                        currentHoveredElem = null;
                    }
                } else {
                    // Moving to another category - just remove grey, new category will show its image
                    removeGreyOut();
                }
            });
        });
    }

    // --- Existing Modal Logic ---
    const modal = section.querySelector('.sbc-modal-overlay');
    const closeBtn = section.querySelector('.sbc-close-btn');
    const diseaseItems = section.querySelectorAll('.sbc-disease-item');

    // We bind the click event to .elem instead of .sbc-card
    const categoryCards = section.querySelectorAll('.elem');

    let selectedCategoryFilter = '';

    // Functions to Open/Close Modal
    const openModal = () => {
        if (modal) {
            modal.style.display = 'flex';
            // Trigger animation
            requestAnimationFrame(() => {
                modal.classList.add('active');
            });
            document.body.style.overflow = 'hidden';
        }
    };

    const closeModal = () => {
        if (modal) {
            modal.classList.remove('active');
            // Wait for animation to complete
            setTimeout(() => {
                modal.style.display = 'none';
            }, 400);
            document.body.style.overflow = '';
        }
    };

    // Card Click Event
    categoryCards.forEach(card => {
        card.addEventListener('click', () => {
            selectedCategoryFilter = card.dataset.filterValue;
            openModal();
        });
    });

    // Close Modal Events
    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    if (modal) {
        modal.addEventListener('click', (e) => {
            if (e.target === modal) closeModal();
        });
    }

    // Disease Selection & Redirection
    // Disease Selection & Redirection
    diseaseItems.forEach(item => {
        item.addEventListener('click', () => {
            const diseaseHandle = item.dataset.handle;

            // Allow fallback if data-handle is missing but we have a URL
            let handle = diseaseHandle;
            if (!handle && item.dataset.url) {
                const match = item.dataset.url.match(/\/collections\/([^\/?#]+)/);
                if (match) handle = match[1];
            }

            if (!handle) return;

            // 1. Base URL: /collections/{condition}
            const baseUrl = window.location.origin + '/collections/' + handle;

            // 2. Construct Search Params
            const params = new URLSearchParams();

            if (selectedCategoryFilter) {
                // Normalize "Home" to "Home and Living"
                // Normalize any potential "Apprel" typo to "Apparel" just in case
                let filterVal = selectedCategoryFilter;
                if (filterVal === 'Home') {
                    filterVal = 'Home and Living';
                } else if (filterVal === 'Apprel') {
                    filterVal = 'Apparel';
                }

                // 3. Category controls ONLY filter.p.product_type
                params.set('filter.p.product_type', filterVal);
            }

            // 4. Final URL Assembly
            // URLSearchParams automatically encodes spaces to "+" in the query string
            const finalUrl = baseUrl + '?' + params.toString();

            window.location.href = finalUrl;
        });
    });

    // Sorting Lists Alphabetically
    const sortList = (listId) => {
        const list = document.getElementById(listId);
        if (!list) return;

        const items = Array.from(list.children);
        items.sort((a, b) => {
            return a.textContent.trim().localeCompare(b.textContent.trim());
        });

        items.forEach(item => list.appendChild(item));
    };

    sortList('sbc-list-mental');
    sortList('sbc-list-chronic');
});

